import { useNavigate } from "react-router-dom";
import { APP_RETIREMENT_URLS, APP_URLS } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import useAppState from "../../../context/AppContext";
import MgpCardForm from "../../../elements/MgpCardForm/MgpCardForm";
import { IApiErrors, IUploadedDoc } from "../../../context/model";
import { downloadUploadedDocument, getPropositionById, validateSubscription } from "../../../services/CustomerApiService";
import { getFilename } from "../../../utils/utils";
import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import LoaderModal from "../../../modals/common/LoaderModal";
import MgpMessage from "../../../elements/MgpMessage/MgpMessage";
import UploadFilePreviewModal from "../../../modals/common/UploadFilePreviewModal";
import { isValidatedProposition } from "../../../utils/dataUtils";


export default function REInfoSignatureDoneBloc() {

    const navigate = useNavigate();
    const {
      state: { signedDocument, proposition, jwtToken, isAuthenticated, validatedPropositionId, reviewMode },
      dispatch,
    } = useAppState();

    const [errorMsg, setErrorMsg] = useState<string | null>();
    const [loading, setLoading] = useState<boolean>(false);
    const [file, setFile] = useState<any>();
    const [modalIsOpen, setModalIsOpen] = useState(false);

     useEffect(() => {
        const fetchProposition = async () => {
            const payload = await getPropositionById(
              jwtToken!.accessToken, 
              proposition!.propositionId
            );
    
            if(!reviewMode && 
              payload && 
              isValidatedProposition(payload.data) && 
              payload.data.propositionId !== validatedPropositionId
            ) {
                validateSubscription(jwtToken!.accessToken, proposition!.propositionId);
                dispatch({type: 'VALIDATED_PROPOSITION', proposition: payload.data})
            }
        }
        if(isAuthenticated && jwtToken && proposition) {
            fetchProposition()
            .catch(console.error);
        }
        
      }, []);
    const onNextAction = async () => {
        const nextUrl = APP_RETIREMENT_URLS.endPage
        dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
        navigate({
            pathname: nextUrl,
            search: `?id=${proposition!.propositionId}`,
        });         
      }
    
      const onPreviousAction = async () => {
        const url = APP_RETIREMENT_URLS.infoSignatureDocumentPage
       
        dispatch({type: 'BACK_INFO_STEP', path: url});
        navigate({
            pathname: url
        });         
      }

      const downloadDocument = async (doc: IUploadedDoc) => {
        try {
          const token = jwtToken!.accessToken;
          const res = await downloadUploadedDocument(token, proposition?.propositionId!, doc.id);
          const fileName = getFilename(res.headers);
          const file = new File([res.data], fileName);
          return file;
        } catch (error) {
          setLoading(false);
    
          const err = error as AxiosError;
          console.log(err);
          if(err.response && err.response.status === 400) {
            const errorData = err.response?.data as IApiErrors;
            setErrorMsg("Erreur: " + errorData.message);
          } else {
            setErrorMsg("Une erreur technique est survenue ");
          }
        }
      }
    
        const previewDoc = async (doc: IUploadedDoc) => {
          const downloadedContent = await downloadDocument(doc);
    
          if (downloadedContent) {
            setFile(downloadedContent);
            setModalIsOpen(true);
          }
        };
    
        const closeModal = () => {
          setModalIsOpen(false);
        };
    
        const handleDownloadDoc = async (doc: IUploadedDoc) => {
          const downloadedContent = await downloadDocument(doc);
    
          if (downloadedContent) {
            const a = document.createElement('a');
            a.download = downloadedContent.name;
            a.href = window.URL.createObjectURL(downloadedContent);
            a.click();
          }
        }

      return (
        <div className="">
          <div className="">
            <div className="form-row mt-md grid-flex">   
                    {signedDocument?.map((doc, i) => 
                        <MgpCardForm key={doc.id}
                          headerElement= {<i className="icon-ecrire fz-lg"></i>}
                          name={doc.name}
                          onDownloadDoc={() => handleDownloadDoc(doc)}
                          onPreviewDoc={() => previewDoc(doc)}
                          buttonName='Télécharger'
                          onClick={() => handleDownloadDoc(doc)}
                        />
                    )}                
                </div>  
                {loading && <LoaderModal hasMessage={false}/>}
                <div>
                  {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
                </div>      

                 {modalIsOpen && file &&<UploadFilePreviewModal file={file as File}  isOpen={modalIsOpen} onCloseModal={closeModal} showButton={false}/>}          
          </div>

          <StickButtonsBloc showPreviousButton={true} disabledPreviousButton={false} nextAction={onNextAction} showNextButton={true} previousAction={onPreviousAction}/>
        </div>
      )
}